import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

const FAQEditor = ({ faqSection, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...faqSection, [field]: value });
  };

  const handleFAQChange = (index, field, value) => {
    const newFAQs = [...faqSection.Faqs];
    newFAQs[index] = { ...newFAQs[index], [field]: value };
    onChange({ ...faqSection, Faqs: newFAQs });
  };

  const addFAQ = () => {
    const newId = (faqSection.Faqs.length + 1).toString().padStart(2, '0');
    onChange({
      ...faqSection,
      Faqs: [...faqSection.Faqs, { id: newId, title: '', description: '' }]
    });
  };

  const removeFAQ = (index) => {
    const newFAQs = faqSection.Faqs.filter((_, i) => i !== index);
    onChange({ ...faqSection, Faqs: newFAQs });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">FAQs Section</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Heading</Form.Label>
          <Form.Control
            type="text"
            value={faqSection.heading}
            onChange={(e) => handleChange('heading', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description Text</Form.Label>
          <Form.Control
            type="text"
            value={faqSection.text}
            onChange={(e) => handleChange('text', e.target.value)}
          />
        </Form.Group>

        <div>
          <h6 className="mb-3">FAQs</h6>
          {faqSection.Faqs.map((faq, index) => (
            <div key={index} className="mb-3 p-3 border rounded">
              <Form.Group className="mb-2">
                <Form.Label>Question</Form.Label>
                <Form.Control
                  type="text"
                  value={faq.title}
                  onChange={(e) => handleFAQChange(index, 'title', e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Answer</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={faq.description}
                  onChange={(e) => handleFAQChange(index, 'description', e.target.value)}
                />
              </Form.Group>

              <Button variant="danger" size="sm" onClick={() => removeFAQ(index)}>
                <i className="fa fa-trash me-1"></i> Remove FAQ
              </Button>
            </div>
          ))}
          <Button variant="outline-primary" size="sm" onClick={addFAQ}>
            <i className="fa fa-plus me-1"></i> Add FAQ
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default FAQEditor;
